<template>
    <v-container fluid tag="section" class="rank-list-container">
        <v-row>
            <v-col cols="12" md="8">
                <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
                    <v-tab v-for="(tab, i) in tabsOrg" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <rank-action-form 
            :listMinistry="listMinistry"
            :listRank="listRank"
            :listUser="listUser"
            :changeModal="changeModal"
            :allowChangeRank="allowChangeRank"
        />
        <rank-table
            :ministries="ministries"
        />
    </v-container>
</template>

<script>
import { OrganizationMachineTabMenu } from "@/pages/organization-machine/organizationContant.js"
import RankTable from './components/RankTable'
import RankActionForm from './components/RankActionForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const organizationMachine = RepositoryFactory.get('organization_machine')
export default {
    components: {
        RankTable,
        RankActionForm
    },

    data() {
        return {
            ministries: [],
            listMinistry: [],
            listRank: [],
            listUser: [],
            userIds: [],
            changeModal: false,
            allowChangeRank: true,
            tabsOrg: []
        }
    },

    created() {
        this.tabsOrg = OrganizationMachineTabMenu()
        this.getList()

        Bus.$on('open-change-rank-modal', () => {
            if (this.userIds.length) {
                this.changeModal = true
            } else {
                this.$swal({
                    title: 'Bạn vui lòng chọn nhân sự muốn chuyển lộ trình làm việc!'
                })
            }
        })

        Bus.$on('close-change-rank-modal', () => {
            this.changeModal = false
            Bus.$emit('reset-change-rank-path')
            this.$swal({
                title: 'Chuyển lộ trình làm việc không thành công',
                timer: 1000
            })
        })

        Bus.$on('add-change-rank-user', (userId) => {
            this.userIds.push(userId)
        })

        Bus.$on('remove-change-rank-user', (userId) => {
            let index = this.userIds.findIndex(id => id == userId)

            if (index > -1) {
                this.userIds.splice(index, 1)
            }
        })

        Bus.$on('change-rank-user', rankId => {
            this.changeRankUser(rankId)
        })

        Bus.$on('action-change-rank', () => {
            this.allowChangeRank = false
        })
    },

    beforeDestroy() {
        Bus.$off('open-change-rank-modal')
        Bus.$off('close-change-rank-modal')
        Bus.$off('add-change-rank-user')
        Bus.$off('remove-change-rank-user')
        Bus.$off('change-rank-user')
        Bus.$off('action-change-rank')
    },

    methods: {
        async getList() {
            const loading = this.$loading.show()
            const res = await organizationMachine.listRankUser()

            if (res.success) {
                this.ministries = _.get(res, 'data', [])

                if (this.ministries.length) {
                    this.ministries.forEach(m => {
                        this.listMinistry.push({
                            id: m.id,
                            name: m.name
                        })

                        m.ranks.forEach(r => {
                            this.listRank.push({
                                id: r.id,
                                name: r.name,
                                ministryId: m.id
                            })
                            this.listUser = this.listUser.concat(r.users.map(u => {
                                return {
                                    ...u,
                                    ministryId: m.id,
                                    rankId: r.id
                                }
                            }))
                        })
                    })
                }
            } else {
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'message', '')
                })
                this.ministries = []
                this.listMinistry = []
                this.listRank = []
                this.listUser = []
            }

            loading.hide()
        },

        async changeRankUser(rankId) {
            const res = await organizationMachine.changeRankUser({
                rankId,
                userIds: this.userIds
            })

            if (res.success) {
                this.userIds = []
                this.changeModal = false
                this.allowChangeRank = true
                this.$swal({
                    title: 'Cập nhật dữ liệu thành công',
                    timer: 1000
                })
                this.getList()
            } else {
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(res, 'messsage', '')
                })
            }

            Bus.$emit('reset-change-rank-path')
        }
    }
}
</script>

<style scoped>
.rank-list-container {
    background-color: white;
}
</style>